import { useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { toggleStyle, menuStyle } from "../../data/dropdownStyles";


function ProgressionDropDown(props) {
  const { levels, changeLevel, changeLevelLen, changeImage, levelBool } = props;


  //console.log("Levels",levels)
  return (
    <Dropdown>
      <Dropdown.Toggle style={toggleStyle} variant="success" id="dropdown-basic">
        Progression
      </Dropdown.Toggle>

      <Dropdown.Menu style={menuStyle}>
        {levels.map((lvl) => (
          <Dropdown.Item
            key={lvl.id}
            onClick={() => {
              changeLevel(lvl.id);
              changeImage("1");
              changeLevelLen(lvl.len)
            }}
            active={levelBool === lvl.id}
          >
            {lvl.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}


export default function FTLOptions(props) {
  useEffect(() => {
  }, []);
  //console.log(props)
  return (
    <div style={{ display: "flex", gap: '1rem' }}>
      
      <ProgressionDropDown {...props}></ProgressionDropDown>

    </div>
  );
}
